module.exports = __webpack_public_path__ + "img/oak.be5030ca.webp";